import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Site } from '@iot-platform/models/i4b';
import { TranslatePipe } from '@ngx-translate/core';
import { CardLoaderComponent } from '../../card-loader/card-loader.component';
import { DetailSiteCardComponent } from '../../detail-popup-cards/detail-site-card/detail-site-card.component';
import { DetailPopupSectionHeaderComponent } from '../../detail-popup/detail-popup-section-header/detail-popup-section-header.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, DetailPopupSectionHeaderComponent, DetailSiteCardComponent, CardLoaderComponent],
  selector: 'iot-platform-ui-site-details-full-info',
  templateUrl: './site-details-full-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./site-details-full-info.component.scss']
})
export class SiteDetailsFullInfoComponent {
  site = input<Site | null>(null);
  // eslint-disable-next-line  @angular-eslint/no-input-rename
  loaded = input<boolean>(false, { alias: 'isSiteLoaded' });

  selectSite = output<Site>();
}
